<template>
	<div>
		<div :class="erro | inputClassErro">
            <label :for="nome">{{ label }}</label>
            <input :id="nome"  class="form-control" 
            	   :name="nome" 
            	   :type="type"
                   :placeholder="placeholder"
                   autofocus>

              <span class="help-block" v-if="erro">
                 <has-error :form="form" :field="nome"/>
              </span>
         </div>	
	</div>	
</template>

<script>

export default{

	name: 'm-input',

	props:{
		erro: {
			default: ''
		}, 
		nClass: {
			type: String,
			default: ''
		}, 
		label: {
			type: String,
			default: ''
		}, 
		form : {
			default: ''
		},
		nome: {
			type: String,
			default: ''
		},
		placeholder: {
			type: String,
			default: ''
		},
		type: {
			type: String,
			default: 'text'
		}
	}

}
	
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/basicos/mInput.vue